import { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { UserRole } from '@fly/shared';
import { useGetCurrentUserProfileQuery } from '@fly/store';

import { FlyLoader, FlyNotFound } from '../../components';

interface RoleGuardProps {
  children: ReactNode;
  allowedRoles?: UserRole[];
  requireAdmin?: boolean;
  showNotFound?: boolean;
  redirectTo?: string;
}

export const RoleGuard = ({
  children,
  requireAdmin = false,
  showNotFound = true,
  redirectTo,
}: RoleGuardProps) => {
  const { data: currentUser, isLoading } = useGetCurrentUserProfileQuery();

  if (isLoading) {
    return <FlyLoader />;
  }
  const isAdmin = currentUser?.isAdmin;

  const isAllowed = requireAdmin && isAdmin;

  if (!isAllowed) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }
    if (showNotFound) {
      return <FlyNotFound />;
    }
    return null;
  }

  return <>{children}</>;
};
